export function Copy() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0862 8H20.0862C20.9146 8 21.5862 8.67157 21.5862 9.5V20.5C21.5862 21.3284 20.9146 22 20.0862 22H11.0862C10.2578 22 9.58618 21.3284 9.58618 20.5V9.5C9.58618 8.67157 10.2578 8 11.0862 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5862 4V3.5C15.5862 2.67157 14.9146 2 14.0862 2H5.08618C4.25775 2 3.58618 2.67157 3.58618 3.5V14.5C3.58618 15.3284 4.25775 16 5.08618 16H5.58618"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
